<template>
  <div class="home">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <clientNavSelector></clientNavSelector>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/coding-questions` }">Coding Questions</el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="loading"></hia-loading>
    <div v-if="!loading" class="top-margin">
      <el-row>
        <el-col :span="20">
          <div style="min-height: 50px;">
            <el-alert type="success" style="float: left; margin-bottom: 20px; font-size: 14px !important;" :closable="false">
              <p>Thank you for exploring this option.</p>
              <p>
                In an effort to expand the support of our client partners, HIA is pleased to announce a new service offering beginning January 1, 2026. Specifically, by utilizing this tab within Nucleus, current clients can submit coding related questions and scenarios to our education department for consideration. Our goal is to provide a well researched and consensus opinion as an unbiased third party based on the information provided.
              </p>

              <p>
                All HIA service agreements moving forward will include a section detailing this service and the applicable charge structure. This service is voluntary and does not involve any cost to you unless you opt in and submit inquiries. The charge is hourly and will be prorated according to the actual amount of time spent addressing the question.
              </p>

              <p>
                For more information, or to sign up, <a href="https://cec2f.share.hsforms.com/2yPUfNoXBSJuIl6Jbw5280A" target="_blank">please click here and we will be in touch shortly.</a>
              </p>
            </el-alert>
          </div>
        </el-col>
        <el-col :span="4">
          <el-tooltip content="Ability to Ask a Question Requires the Coding Questions Role in Nucleus Admin. Please contact your administrator." placement="top" :disabled="!hasContractNotRole">
            <el-button @click="createNewQuestion" type="primary" icon="el-icon-plus" class="pull-right" :disabled="newButtonDisabled">New Question </el-button>
          </el-tooltip>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div style="float: right; margin: 10px 0px 10px 0px;">
            <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
          </div>
          <el-table ref="codingQuestionsList" :data="filteredCodingQuestions" style=" margin-top: 20px;" :height="filteredCodingQuestions.length > 8 ? '55vh' : 'auto'">
            <el-table-column prop="title" label="Title" sortable>
              <template slot-scope="scope">
                <router-link :to="`coding-questions/${scope.row.questionId}`">{{ scope.row.title }}</router-link>
              </template>
            </el-table-column>
            <el-table-column prop="contact" label="Created By" sortable></el-table-column>
            <el-table-column prop="status" label="Status" width="150" sortable></el-table-column>
            <el-table-column prop="insertDate" label="Created" sortable>
              <template slot-scope="scope">
                {{ format(parseISO(scope.row.insertDate), 'M/d/yyyy hh:mm a') }}
              </template>
            </el-table-column>
            <el-table-column prop="insertDate" label="Modified" sortable>
              <template slot-scope="scope">
                {{ format(parseISO(scope.row.lastModified), 'M/d/yyyy hh:mm a') }}
              </template>
            </el-table-column>
            <template slot="empty">
              <p>No Coding Questions Available</p>
            </template>
          </el-table>
          <div id="codingQuestionsTableStats">
            <p>{{ `${filteredCodingQuestions.length} Coding Questions` }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { mapState, mapActions } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import hiaFilters from '@/mixins/hiaFilters'

export default {
  mixins: [HiaAuthorization, hiaFilters],
  data: function() {
    return {
      loading: true,
      format: format,
      parseISO: parseISO,
      filterCriteria: ''
    }
  },
  name: 'codingQuestionsList',
  components: {},
  methods: {
    ...mapActions('codingQuestions/', ['GET_CODING_QUESTIONS']),
    initialize() {
      this.loading = true
      this.GET_CODING_QUESTIONS().then(() => {
        this.loading = false
        this.$nextTick(() => {
          const table = this.$refs.codingQuestionsList
          if (table) {
            table.doLayout()
          }
        })
      })
    },
    createNewQuestion() {
      this.$router.push('coding-questions/new')
    }
  },
  created: function() {
    this.initialize()
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId', 'clients']),
    ...mapState('codingQuestions/', ['codingQuestions']),
    filteredCodingQuestions() {
      if (this.codingQuestions.length) {
        return this.filterList(this.codingQuestions, this.filterCriteria, ['title', 'contact', 'question', 'answer', 'status', 'insertDate', 'lastModified'])
      }
      return []
    },
    isCodingQuestionsClient() {
      if (['SRHSQ', '1DEMQ'].includes(this.currentClient)) {
        return true
      }
      let clientObj = this.clients.find(x => x.clientNumber === this.currentClient)
      return clientObj.codingQuestionsActive
    },
    newButtonDisabled() {
      return !this.isCodingQuestionsClient || !this.isCodingQuestion()
    },
    hasContractNotRole() {
      return this.isCodingQuestionsClient && !this.isCodingQuestion()
    }
  }
}
</script>

<style scoped>
>>> .el-alert__description {
  font-size: 14px;
}

>>> .cell {
  word-break: break-word;
}

/* CODING QUESTIONS TABLE STATS */
#codingQuestionsTableStats {
  padding: 0px 0px 0px 0px;
  margin: 7px 0px 0px 15px;
}

#codingQuestionsTableStats p {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  font-size: 12px;
  font-weight: normal;
  color: #606266;
}
</style>
